import { render, staticRenderFns } from "./seccionDocumentos.vue?vue&type=template&id=073aebb8&"
import script from "./seccionDocumentos.vue?vue&type=script&lang=js&"
export * from "./seccionDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports